import React from "react";

const LOOKBACK_COPY = "the last 6 months";

type KeywordInputTooltipProps = {
  count?: number;
  warning: boolean | 0 | undefined;
};

export default function KeywordInputTooltip({ count, warning }: KeywordInputTooltipProps) {
  if (count === 0) {
    return <>No matches in {LOOKBACK_COPY}</>;
  }
  if (warning) {
    return <>Generic keyword — may pull in irrelevant notices</>;
  }
  if (count === undefined) {
    return <>Notices matched in {LOOKBACK_COPY}</>;
  }
  return (
    <>
      Matched {count.toLocaleString()} notice{count === 1 ? "" : "s"} in {LOOKBACK_COPY}
    </>
  );
}
